let url = "";
let cashbarberFrontendUrl = "";
let adminUrl = "";
let url_ai = "";

if (process.env.NODE_ENV === "development") {
  url = process.env.REACT_APP_URL;
  url_ai = process.env.REACT_APP_URL_AI;
  cashbarberFrontendUrl = process.env.REACT_FRONTEND_CASHBARBER_URL;
  adminUrl = "http://localhost:3000";
} else if (process.env.REACT_APP_STAGE === "homolog") {
  url = "https://dev.api.cashbarber.com.br";
  cashbarberFrontendUrl = "http://dev.painel.cashbarber.com.br";
  url_ai = "https://api-ai.cashbarber.com.br";
  adminUrl = "https://dev.admin.cashbarber.com.br";
} else {
  url = "https://api.cashbarber.com.br";
  cashbarberFrontendUrl = "http://painel.cashbarber.com.br";
  url_ai = "https://api-ai.cashbarber.com.br";
  adminUrl = "https://admin.cashbarber.com.br";
}

export const Constants = {
  url: url,
  url_ai: url_ai,
  backendUrl: `${url}/api`,
  baseUrl: `${url}/api/pump`,
  baseUrlAI: url_ai + "/api/web",
  cashbarberFrontendUrl: cashbarberFrontendUrl,
  adminUrl: adminUrl,
};
